
if (window.location.pathname === "/cart") {
    window.location.href = "/?cart=open";
}

$(document).ready(function () {
    refreshCart()

    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('cart') && urlParams.get('cart') === 'open') {
        openCart();
    }
});

// open cart on navigation
$('#header .nav-cart').on('click', function() {
    openCart();
});

function openCart() {
    $('#popup-cart').css('display', 'flex');
    $('body').css('overflow-y', 'hidden');

    setTimeout(() => {
        $('#popup-cart .cart').css('opacity', 1);
    }, 10);
}

// close cart
$('#popup-cart .cart-close').on('click', function() {
    closeCart();
});

function closeCart() {
    $('#popup-cart').css('display', 'none');
    $('body').css('overflow-y', 'visible');
    $('#popup-cart .cart').css('opacity', 0);
}

// preventing scroll
function preventScroll(event) {
    event.preventDefault();
}

// form add to cart
$('.atc-form').on('submit', function (event) {
    event.preventDefault();
    let formData = $(this).serialize();

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        success: function (response) {
            refreshCart();
            openCart();
        },
        error: function (xhr, status, error) {
            console.error('Error adding product to cart:', error);
        }
    });
});

// item remove to cart
$(document).on('click', '.product-remove', function(event) {
    event.preventDefault();

    let removeUrl = $(this).attr('href'); 

    $.ajax({
        type: 'POST',
        url: removeUrl,
        success: function() {
            refreshCart();
        },
        error: function(xhr, status, error) {
            console.error('Error removing item:', error);
        }
    });
});

// update quantity
var qtyTimer;
function updateQty(updateUrl) {
    clearTimeout(qtyTimer);
    qtyTimer = setTimeout(function() {
        $.ajax({
            type: 'POST',
            url: updateUrl,
            success: function() {
                refreshCart();
            },
            error: function(xhr, status, error) {
                console.error('Error updating item:', error);
            }
        });
    }, 300);
}
$(document).on('click', '#popup-cart .less_qty', function() {
    let key = $(this).data('key');
    let qty = $(`#popup-cart .qty[data-key="${key}"]`).val();

    if (qty > 1) {
        qty--;

        let updateUrl = `/cart/change?id=${key}&quantity=${qty}`;

        $(`#popup-cart .qty[data-key="${key}"]`).val(qty);

        updateQty(updateUrl);
    }
});
$(document).on('click', '#popup-cart .add_qty', function() {
    let key = $(this).data('key');
    let qty = $(`#popup-cart .qty[data-key="${key}"]`).val();

    if (qty < 100) {
        qty++;

        let updateUrl = `/cart/change?id=${key}&quantity=${qty}`;
        
        $(`#popup-cart .qty[data-key="${key}"]`).val(qty);

        updateQty(updateUrl);
    }
});

// refresh cart
function refreshCart() {
    
    $('#popup-cart .el-overlay').show();
    $('#popup-cart .option').css('right', '-100%');

    $.ajax({
        type: 'GET',
        url: window.location.href,
        dataType: 'html',
        success: function(cartHtml) {
            let newCartItems = $(cartHtml).find('.cart-body').html();
            $('#popup-cart .cart-body').html(newCartItems);

            let newCartTotal = $(cartHtml).find('.cart-total-price').html();
            $('#popup-cart .cart-total-price').html(newCartTotal);

            if ($(cartHtml).find('.cart-body').find('.product').length == 0) {
                $('#popup-cart .btn-atc').addClass('disabled');
                $('#header .nav-cart .dot').hide();
            }
            else {
                $('#popup-cart .btn-atc').removeClass('disabled');
                $('#header .nav-cart .dot').show();
            }
                

            $('#popup-cart .el-overlay').hide();
        },
        error: function(xhr, status, error) {
            console.error('Error fetching cart data:', error);
            $('#popup-cart .el-overlay').hide();
        }
    });
}

// close if away
$(document).on('click', function (event) {
    if ($('#popup-cart').css('display') == 'flex' && !$(event.target).closest('.cart').length && !$(event.target).parent().hasClass('nav-cart')) {
        closeCart();
    }
});